import { ReactNode } from 'react'

import Box from '@ilg-totallymoney/ui/components/Box'
import Grid from '@ilg-totallymoney/ui/components/Grid'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Text from '@ilg-totallymoney/ui/components/Text'
import WaveDivider from '@ilg-totallymoney/ui/components/WaveDivider'

interface SectionWrapperProps {
    backgroundColor?: string
    backgroundTexture?: ReactNode
    children: ReactNode
    hasWave?: boolean
    id?: string
    supportingText?: string
    title?: string
    waveColor?: string
}

const SectionWrapper = ({
    backgroundColor = 'white',
    backgroundTexture,
    children,
    hasWave = false,
    id,
    supportingText,
    title,
    waveColor,
}: SectionWrapperProps) => (
    <Box position="relative" id={id}>
        {hasWave && (
            <Box
                position="absolute"
                top={['-space30', '-space30', '-space40']}
                left={0}
                right={0}
            >
                <WaveDivider waveColor={waveColor ?? backgroundColor} />
            </Box>
        )}

        <Box
            background={backgroundColor}
            pb={['space80', 'space100']}
            pt="space50"
            position="relative"
            overflow="hidden"
        >
            <Box zIndex={0} position="absolute" size="100%">
                {backgroundTexture}
            </Box>

            <Grid style={{ position: 'relative', zIndex: 1 }}>
                {title ? (
                    <Box mb="space30" gridColumn="1/13">
                        <Heading variant="100" textAlign="center">
                            {title}
                        </Heading>
                    </Box>
                ) : null}

                {supportingText ? (
                    <Box mb="space30" gridColumn={['1/13', '1/13', '3/11']}>
                        <Text color="light" textAlign="center" variant="120">
                            {supportingText}
                        </Text>
                    </Box>
                ) : null}

                {children}
            </Grid>
        </Box>
    </Box>
)

export default SectionWrapper
